(function () {
  // Shopifyの金額は最小単位（円×100）。表示時のみ円に戻す
  const formatYen = (amountInSubunits) => {
    const yen = Math.round((Number(amountInSubunits) || 0) / 100);
    return `¥${yen.toLocaleString('ja-JP')}`;
  };

  window.updateFreeShippingNudges = function (cartTotal) {
    document.querySelectorAll('[data-free-shipping-nudge]').forEach((el) => {
      const threshold = Number(el.dataset.threshold || 1000000);
      const total = Number(cartTotal || 0);
      const remaining = Math.max(threshold - total, 0);
      const progress = total <= 0 ? 0 : threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
      const qualified = total >= threshold && total > 0;
      const messageEl = el.querySelector('[data-free-shipping-message]');
      const barEl = el.querySelector('[data-free-shipping-bar]');
      const fillEl = el.querySelector('[data-free-shipping-fill]');
      el.classList.toggle('is-qualified', qualified);
      el.dataset.cartTotal = String(total);
      el.hidden = false;

      if (messageEl) {
        if (total <= 0) {
          messageEl.innerHTML = `税込<span class="free-shipping-nudge__em">${formatYen(
            threshold
          )}以上</span>のお買い上げで<span class="free-shipping-nudge__em">送料0円</span>`;
        } else if (qualified) {
          messageEl.innerHTML = `<span class="free-shipping-nudge__badge">送料無料</span><span class="free-shipping-nudge__text">送料無料条件を達成しました！</span>`;
        } else {
          messageEl.innerHTML = `あと<span class="free-shipping-nudge__em">${formatYen(
            remaining
          )}</span>で<span class="free-shipping-nudge__em">送料0円</span>(税込${formatYen(threshold)}以上)`;
        }
      }

      if (barEl) barEl.setAttribute('aria-valuenow', String(Math.round(progress)));
      if (fillEl) fillEl.style.width = `${progress}%`;
    });
  };
})();
